import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { messages } from '../../i18n';

const propTypes = {

	/**
	 * The function for the click event for creating a new Miro board card.
	 */
	 onCreateBoard: PropTypes.func.isRequired,

};

const NewMiroBoardCard = ({ onCreateBoard }) => {

	const intl = useIntl();

	return (
		<button
			className="tc-btn-wrapper btn btn-primary new-card"
			onClick={onCreateBoard}>
			<div className="justify-content-end align-items-center">
				<div className="plus-icon">
					<i
						className="fal fa-plus"
						aria-hidden="true">
					</i>
				</div>
				<div
					className="pl-2">
					{intl.formatMessage(messages.TC_COMPONENTS_MIRO_BOARD_SELECTOR_NEW_BOARD)}
				</div>
			</div>
		</button>
	);

};

NewMiroBoardCard.propTypes = propTypes;

export default NewMiroBoardCard;
